import { createBrowserRouter, redirect } from "react-router-dom";
import AdminPanel from "../pages/AdminPanel";
import EnrolledStudents from "../pages/EnrolledStudents1";
import Dashboard from "../pages/Dashboard";
import Dashboard1 from "../pages/Dashboard1"; // Make sure this import is correct
import EmployeeLogin from "../pages/EmployeeLogin";
import AllEmployees from "../pages/AllEmployees";
import EmployeePage from "../pages/EmployeePage";
import SearchStudents from "../pages/SearchStudents";
import EnrollStudent from "../pages/EnrollStudent";
import AllConsultants from "../pages/AllConsultants";
import ExcelUploadPage from "../pages/ExcelUploadPage";
import AssignedStudents from "../pages/AssignedStudents";
import InterestedStudents from "../pages/InterestedStudents";
import NotInterestedStudents from "../pages/NotInterestedStudents";
import MostInterestedStudents from "../pages/MostInterestedStudents";
import CallBackStudents from "../pages/CallBackStudents";
import NotAnswered from "../pages/NotAnswered";
import EmployeeReport from "../pages/EmployeeReport";
import EmployeeCallLogs from "../pages/EmployeeCallLogs";
import TeamLeadEmployees from "../pages/TeamLeadEmployees";
import TeamLeadEmployeeData from "../pages/TeamLeadEmployeeData";
import NoAccess from "../pages/Noaccess";
import AllTeamLeads from "../pages/AllTeamLeads";
import TeamlLeadHistory from '../pages/TeamlLeadHistory'
import TeamLeadTaskReport from "../pages/TeamLeadTaskReport";
import CallDuration from "../pages/CallDuration";
import TeamLeadRemainders from "../pages/TeamLeadRemainders";
import TeamLeadAllEmpData from "../pages/TeamLeadAllEmpData";
import EmpTeamLead from "../pages/EmpTeamLead";
import EmpTeamLeadHistory from "../pages/EmpTeamLeadHistory";
import CreateNotification from "../pages/CreateNotification";
import ClosedLeads from "../pages/ClosedLeads";
import TeamLeadAllLeads from "../pages/TeamLeadAllLeads";
import TeamleadUploadExcelPromotionData from "../pages/TeamleadUploadExcelPromotionData";
import TeamleadExcelPromotionDataReport from "../pages/TeamleadExcelPromotionDataReport";
import EmployeeExcelPromotionDataReport from "../pages/EmployeeExcelPromotionDataReport";
import AllDistrict from "../pages/AllDistrict";
import AllCities from "../pages/AllCities"
import AllUploadedData from "../pages/AllUploadedData"
import CallCheckList from "../pages/CallCheckList"
import DigitalMarketingLeads from "../pages/DigitalMarketingLeads";
import ParentEmployeeChecklist from "../pages/ParentEmployeeChecklist"
import EmployeeCallWeeklyReport from "../pages/EmployeeCallWeeklyReport";
import AllActiveEmployees from "../pages/AllActiveEmployees";
import UniversityManagement from "../pages/Universitymanagement";
import AssignUniversity from "../pages/AssignUniversity";

// import ErrorBoundary from "../components/ErrorBoundary"; 
// import NotFound from "../components/NotFound"; 

// Helper function to check memberType (used in route guards)
const checkUserRole = (requiredRoles) => {
  const encodedMemberType = sessionStorage.getItem("K3M8X1JQ5VZ4B7PWTL9");
  if (encodedMemberType) {
    const decodedMemberType = atob(encodedMemberType);
    // Check if the decoded role is in the required roles array
    if (requiredRoles.includes(decodedMemberType)) {
      return true;
    }
    return false;
  }
  return false;
};

// ✅ Added helper for mobile detection
const isMobileDevice = () =>
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

// Router configuration
const router = createBrowserRouter([
  {
    path: "/employee-login",
    element: <EmployeeLogin />,
  },
  {
    path: "/",
    element: isMobileDevice() ? <NoAccess /> : <AdminPanel />, // ✅ redirect mobile to error
    children: [
      // DEFAULT ROUTE - You have two options:
      // Option 1: Dashboard as default (current setup)
      { path: "", element: <Dashboard /> },

      // Option 2: Add dashboard1 as alternative default
      // { path: "", element: <Dashboard1 /> }, // Uncomment this to make Dashboard1 the default

      // ADD THE DASHBOARD1 ROUTE HERE:
      {
        path: "dashboard1",
        element: <Dashboard1 />,
        // Optional: Add error boundary
        // errorElement: <ErrorBoundary />,
      },

      // Or if you want it to be accessible via /dashboard1 (not nested)
      // Keep the above for /dashboard1 and also add this:
      {
        path: "university-management",
        element: <UniversityManagement />,
        loader: () => {
          if (!checkUserRole(["Admin"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "parent-employee-checklist",
        element: <ParentEmployeeChecklist />,
      },
      {
        path: "assign-university",
        element: <AssignUniversity />,
        loader: () => {
          if (!checkUserRole(["Admin"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "district",
        element: <AllDistrict />,
      },
      {
        path: "city",
        element: <AllCities />,
      },
      {
        path: "call-checklist",
        element: <CallCheckList />,
      },
      {
        path: "All-Uploaded-Data",
        element: <AllUploadedData />,
      },
      {
        path: "employee-team-lead",
        element: <EmpTeamLead />,
      },
      {
        path: "emp-team-lead-history/:studentId",
        element: <EmpTeamLeadHistory />,
      },
      {
        path: "enrolled-students",
        element: <EnrolledStudents />,
      },
      {
        path: "interested-students",
        element: <InterestedStudents />,
      },
      {
        path: "not-interested-students",
        element: <NotInterestedStudents />,
      },
      {
        path: "most-interested-students",
        element: <MostInterestedStudents />,
      },
      {
        path: "callback-students",
        element: <CallBackStudents />,
      },
      {
        path: "not-answered-students",
        element: <NotAnswered />,
      },
      {
        path: "today-task",
        element: <AssignedStudents />,
      },
      {
        path: "all-employees",
        element: <AllEmployees />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
  path: "all-active-employees",
  element: <AllActiveEmployees />,
},
      {
        path: "create-notification",
        element: <CreateNotification />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "closed-lead",
        element: <ClosedLeads />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "/employee/:employee_id",
        element: <EmployeePage />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "all-teamLeads",
        element: <AllTeamLeads />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "teamlead-task-report",
        element: <TeamLeadTaskReport />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "employee-call-duration",
        element: <CallDuration />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "search-students",
        element: <SearchStudents />,
      },
      {
        path: "/no-access", // ✅ added route
        element: <NoAccess />,
      },
      {
        path: "my-employees",
        element: <TeamLeadEmployees />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "my-team-data",
        element: <TeamLeadAllLeads />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "my-history",
        element: <TeamlLeadHistory />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "my-employees/:employee_id",
        element: <TeamLeadEmployeeData />,
        loader: () => {
          const encodedMemberType = sessionStorage.getItem(
            "K3M8X1JQ5VZ4B7PWTL9"
          );
          if (!encodedMemberType || atob(encodedMemberType) !== "Team Lead" === "Admin") {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "tl-remainders",
        element: <TeamLeadRemainders />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager", "Employee"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "my-team-leads",
        element: <TeamLeadAllEmpData />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "enroll-student",
        element: <EnrollStudent />,
        loader: () => {
          if (!checkUserRole(["Employee", "Consultant", "Digital Leads"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "excel-upload",
        element: <ExcelUploadPage />,
        loader: () => {
          if (!checkUserRole(["Admin"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "employee-task-report",
        element: <EmployeeReport />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },
      {
        path: "employee-calllogs",
        element: <EmployeeCallLogs />,
        loader: () => {
          if (!checkUserRole(["Admin", "Manager"])) {
            return redirect("/"); // Redirect if user doesn't have the required role
          }
          return null; // Return null if no further action is needed
        },
      },


      {
        path: "my-team-leads",
        element: <TeamLeadAllEmpData />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },





      {
        path: "upload-excel-data",   // 👈 same as key
        element: <TeamleadUploadExcelPromotionData />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },





      {
        path: "promotion-excel-report",   // 👈 same as key
        element: <TeamleadExcelPromotionDataReport />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },

      {
        path: "employee-promotion-excel-report",   // 👈 same as key
        element: <EmployeeExcelPromotionDataReport />,
        loader: () => {
          if (!checkUserRole(["Employee", "Digital Leads"])) {
            return redirect("/");
          }
          return null;
        },
      },


      {
        path: "digital-marketing-leads",   // 👈 same as key
        element: <DigitalMarketingLeads />,
        loader: () => {
          if (!checkUserRole(["Admin", "Team Lead", "Manager"])) {
            return redirect("/");
          }
          return null;
        },
      },
      {
        path: "employee-call-weekly-report",
        element: <EmployeeCallWeeklyReport />,
      },


      // Add a catch-all 404 route at the end
      // {
      //   path: "*",
      //   element: <NotFound />,
      // },
    ],
  },

  // Alternative: Add Dashboard1 as a separate top-level route (outside AdminPanel)
  // {
  //   path: "/dashboard1",
  //   element: <Dashboard1 />,
  // },
]);

export default router;